import { render, staticRenderFns } from "./AppAddDeclarationFetchError.vue?vue&type=template&id=7ef9b4ae&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports